import React from "react"

interface SectionTitleProps {
  title: string
}

const Sectiontitle: React.FC<SectionTitleProps> = ({ title }) => {
  return (
    <div className="mi-sectiontitle">
      <h2>{title}</h2>
      <span>{title}</span>
    </div>
  )
}

export default Sectiontitle
